import * as React from "react";

const LoginIcon = ({ theme }) => {
  const color = theme === "light" ? "#232A47" : "#F1F5F9";

  return (
    <div className="relative p-2 rounded-full hover:bg-blackPrimaryText hover:bg-opacity-10 dark:hover:bg-darkModeBlackPrimaryText dark:hover:bg-opacity-10 active:scale-95 transition-all duration-150 flex items-center justify-center">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">

        <path
          d="M15 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H15"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        <path
          d="M9 7L4 12L9 17"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        <path
          d="M4 12H16"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export default LoginIcon;